import FilterItem from "../../assets/components/FilterItem";

const FormFilters = ({ handleClick, selected }) => {
  return (
    <div className="w-100 mt-1 mb-4 d-flex">
      <FilterItem
        title={"همه"}
        handleClick={() => handleClick("Active")}
        selected={selected === "Active"}
      />
      <FilterItem
        title={"آرشیو"}
        handleClick={() => handleClick("Archived")}
        selected={selected === "Archived"}
      />
    </div>
  );
};

export default FormFilters;
